import { createContext } from 'react';

export const AuthContext = createContext(null);

// Return user or null
export function useAuth() {

    if (localStorage.getItem('motus_access_token') != null) {
        return({id:localStorage.getItem('motus_user_id'), token: localStorage.getItem('motus_access_token')});
    }
    else return null;
}